import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const decryptAES = (encryptedPayload) => {
    try {
        // 키 생성 (Python과 동일한 방식)
        const key = CryptoJS.SHA256(SECRET_KEY);

        // Base64 디코딩
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedPayload);

        // IV 추출 (첫 16바이트 = 4워드)
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4));

        // Ciphertext 추출 (나머지)
        const ciphertext = CryptoJS.lib.WordArray.create(
            encryptedBytes.words.slice(4),
            encryptedBytes.sigBytes - 16
        );

        // 복호화
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: ciphertext },
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // UTF-8로 변환 후 JSON 파싱
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        //console.log('Decrypted text:', decryptedText);

        return JSON.parse(decryptedText);

    } catch (error) {
        console.error('Decryption failed:', error);
        return null;
    }
}
